import { render, staticRenderFns } from "./DismissalTagConfig.vue?vue&type=template&id=07729fc2&scoped=true"
import script from "./DismissalTagConfig.vue?vue&type=script&lang=js"
export * from "./DismissalTagConfig.vue?vue&type=script&lang=js"
import style0 from "./DismissalTagConfig.vue?vue&type=style&index=0&id=07729fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07729fc2",
  null
  
)

export default component.exports